import { Colors } from '@sigma-frontend-libs/commons'

import { services } from '@/utils'

import tag from '@/components/tag'

const baseClass = 'price-calculation'

function renderTitle(h) {
  return h(
    tag,
    {
      props: {
        color: Colors.grey,
        label: this.getTranslate(`${services.billings}.labels.priceCalculation`)
      }
    }
  )
}

function renderType(h, row) {
  return h(
    'div',
    {
      class: `${baseClass}-row__type`
    },
    [ row.typeLabel ]
  )
}
function renderField(h, field) {
  return h(
    'div',
    {
      class: `${baseClass}-field`,
      key: field.key
    },
    [
      h(
        'div',
        {
          class: `${baseClass}-field__label`
        },
        [ field.label ]
      ),
      h(
        'div',
        {
          class: `${baseClass}-field__value`
        },
        [ String(field.value) ]
      )
    ]
  )
}
function renderFields(h, row) {
  let fields = []
  if (Array.isArray(row.fields)) {
    fields = row.fields
  }

  return fields.map(field => {
    return renderField.call(this, h, field)
  })
}
function renderAmount(h, row) {
  return h(
    'div',
    {
      class: `${baseClass}-row__amount`
    },
    [ row.amount ]
  )
}
function renderRow(h, row, rowKey) {
  return h(
    'div',
    {
      class: `${baseClass}-row`,
      key: rowKey
    },
    [
      renderType.call(this, h, row),
      ...renderFields.call(this, h, row),
      renderAmount.call(this, h, row)
    ]
  )
}
function renderRows(h, group) {
  return group.rows.map((row, rowIndex) => {
    return renderRow.call(this, h, row, `${group.key}:${rowIndex}`)
  })
}
function renderTotal(h, group) {
  return h(
    'div',
    {
      class: `${baseClass}-group__total`
    },
    [
      h(
        'div',
        {
          class: `${baseClass}-group__total-label`
        },
        [ group.totalTitle ]
      ),
      h(
        'div',
        {
          class: `${baseClass}-group__total-value`
        },
        [ group.total ]
      )
    ]
  )
}
function renderGroup(h, group) {
  return h(
    'div',
    {
      class: [
        `${baseClass}-group`,
        `${baseClass}-group--${group.key}`
      ],
      key: group.key
    },
    [
      ...renderRows.call(this, h, group),
      renderTotal.call(this, h, group)
    ]
  )
}
function renderGroups(h) {
  return h(
    'div',
    {
      class: `${baseClass}__groups`
    },
    [
      ...this.groups.map(group => {
        return renderGroup.call(this, h, group)
      })
    ]
  )
}

export default function(h) {
  if (this.hasGroups) {
    return h(
      'div',
      {
        class: baseClass
      },
      [
        renderTitle.call(this, h),
        renderGroups.call(this, h)
      ]
    )
  }
}
